import { render, staticRenderFns } from "./twm_sso.vue?vue&type=template&id=4c45fd35&scoped=true&"
import script from "./twm_sso.vue?vue&type=script&lang=js&"
export * from "./twm_sso.vue?vue&type=script&lang=js&"
import style0 from "./twm_sso.vue?vue&type=style&index=0&id=4c45fd35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c45fd35",
  null
  
)

export default component.exports